import { isCEPEmpty, isCNPJEmpty, isValidCNPJ, validDDDs } from 'utils/basicUtils';
import { businessFormInitialValues } from './../utils';
import Yup from 'utils/validation';

export const toursInitialValues = {
  ...businessFormInitialValues,
  tour: {
    id: '',
    attractions: '',
    equipments: '',
    businessId: 0,
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
  },
};

export const toursValidationSchema = Yup.object().shape({
  id: Yup.number(),
  businessRepresentative: Yup.string()
    .notRequired()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
  businessOwner: Yup.array().of(
    Yup.string()
      .notRequired()
      .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0)
  ),
  businessType: Yup.string()
    .notRequired()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
  description: Yup.string()
    .notRequired()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
  document: Yup.string().notRequired(),
  experiences: Yup.array().notRequired(),
  googleMapsLink: Yup.string()
    .notRequired()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
  tradeEmail: Yup.string().notRequired(),
  tradeName: Yup.string()
    .notRequired()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
  title: Yup.string()
    .notRequired()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
  phone: Yup.string().notRequired(),
  site: Yup.string().notRequired(),
  youtubeLink: Yup.string().notRequired(),
  instagramLink: Yup.string().notRequired(),
  facebookLink: Yup.string().notRequired(),
  whatsapp: Yup.string().notRequired(),
  image: Yup.array().notRequired(),
  address: Yup.object().shape({
    id: Yup.number(),
    city: Yup.string()
      .notRequired()
      .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
    neighborhood: Yup.string()
      .notRequired()
      .test(
        'not-only-numbers',
        'O bairro não pode conter somente números',
        value => !value || /^(?!^\d+$)[\d\D]*$/.test(value)
      )
      .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
    number: Yup.string()
      .notRequired()
      .test('only-numbers', 'O campo número deve conter apenas números', value => !value || /^\d*$/.test(value))
      .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
    state: Yup.string()
      .notRequired()
      .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
    street: Yup.string()
      .notRequired()
      .test(
        'not-only-numbers',
        'O campo endereço não pode ser apenas números',
        value => !value || /^(?!\d+$).*/.test(value)
      )
      .test('not-empty', 'Campo não pode conter apenas espaços', value => !value || value.trim().length > 0),
    zipCode: Yup.string().notRequired(),
  }),
  images: Yup.array().notRequired(),
  tour: Yup.object().shape({
    id: Yup.number(),
    attractions: Yup.string(),
    equipments: Yup.string(),
  }),
});
